var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-header project-inner w-nav",style:({ backgroundColor: _vm.color || _vm.DEFAULT_COLOR })},[_c('div',{staticClass:"header-container"},[_vm._t("default")],2),_c('div',{staticClass:"w-nav-overlay"})])}
var staticRenderFns = []

export { render, staticRenderFns }